import type { CustomToastOptions } from '@kc-console/common-ui';
import type { Replace } from '@kc-console/core';
import type {
  SnackbarOrigin as ToastOrigin,
  SnackbarProviderProps as NotistackToastProviderProps,
} from 'notistack';

export const INITIAL_TOAST_AUTO_HIDE_DURATION = 3000;

declare module 'notistack' {
  interface VariantOverrides {
    default: false;
    error: CustomToastOptions;
    info: CustomToastOptions;
    success: CustomToastOptions;
    warning: false;
  }
}

type OverrideToastProviderProps = {
  /**
   * 스크린에서 토스트가 표시될 위치를 지정합니다.
   *
   * @default { vertical: 'bottom', horizontal: 'right' }
   */
  anchorOrigin?: ToastOrigin;

  /**
   * 토스트가 자동으로 닫힐 시간(milliseconds)을 지정합니다. `null`로 지정하면 자동으로 닫히지 않게 합니다.
   * @default 3000 (ms)
   */
  autoHideDuration?: number | null;

  /**
   * 각 `variant`에 해당하는 토스트 커스텀 컴포넌트를 매핑합니다.
   */
  Components?: NotistackToastProviderProps['Components'];

  /**
   * 각 `variant`에 해당하는 아이콘 커스텀 컴포넌트를 매핑합니다.
   */
  iconVariant?: NotistackToastProviderProps['iconVariant'];

  /**
   * 토스트를 한번에 표시할 수 있는 최대 개수를 지정합니다.
   *
   * @default 3
   */
  maxSnack?: number;
};

export type ToastProviderProps = Replace<NotistackToastProviderProps, OverrideToastProviderProps>;
